import { renderToStaticMarkup } from 'react-dom/server';
import languages from './languages';

export default function initLocalize({ initialize, addTranslationForLanguage }) {
    const langs = Object.keys(languages).map(key => ({ name: key, code: key }));
    initialize({
        languages: langs,
        translation: languages,
        options: {
            renderToStaticMarkup,
            renderInnerHtml: true,
            defaultLanguage: 'en',
            onMissingTranslation: ({ translationId, defaultTranslation }) => {
                let defaultTranslationText = defaultTranslation;
                if (defaultTranslation.props && defaultTranslation.props.dangerouslySetInnerHTML) {
                    defaultTranslationText = defaultTranslation.props.dangerouslySetInnerHTML.__html;
                }
                return defaultTranslation ===
                    "No default translation found! Ensure you've added translations for your default langauge."
                    ? translationId
                    : defaultTranslationText;
            },
        },
    });
    langs.forEach(({ code }) => {
        addTranslationForLanguage(languages[code], code);
    });
    return langs;
}
